import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import ProgressiveImage from "react-progressive-image";
import { Link } from "react-router-dom";
import hdBadge from "../assets/hd-badge.svg";

const ChannelStyles = css`
  position: relative;
  display: block;
  width: 218px;
  margin: 0 5px 20px 5px;
  text-align: center;

  img {
    border-radius: 4px;
  }

  &:before {
    content: "";
    position: ${(props) => (props.flag !== "false" ? "absolute" : "static")};
    top: 0;
    right: 0;
    visibility: ${(props) => (props.flag !== "false" ? "visible" : "hidden")};
    width: 40px;
    height: 25px;
    background: ${(props) => `url(${props.flag}) center center no-repeat;`};
  }

  &:after {
    content: "";
    position: ${(props) => (props.hd !== "false" ? "absolute" : "static")};
    right: 0;
    bottom: 27.5px;
    visibility: ${(props) => (props.hd !== "false" ? "visible" : "hidden")};
    width: 40px;
    height: 25px;
    background: url(${hdBadge}) center center no-repeat;
  }
`;

const ChannelLink = styled(Link)`
  ${ChannelStyles}
`;

const RadioButton = styled.button`
  ${ChannelStyles}
`;

class ChannelItem extends React.Component {
  static propTypes = {
    channelType: PropTypes.oneOf(["tv", "radio"]).isRequired,
    id: PropTypes.number.isRequired,
    picture: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    isHd: PropTypes.bool,
    countryIcon: PropTypes.string,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    isHd: "false",
    countryIcon: "",
    onClick: null,
  };

  render() {
    const { channelType, id, picture, title, isHd, countryIcon, onClick } =
      this.props;

    return channelType === "radio" ? (
      <RadioButton
        key={id}
        to={`/${channelType}/${id}/${title}`}
        type="button"
        flag={countryIcon}
        hd={`${isHd}`}
        style={{
          width: 218,
          margin: "0 10px 20px",
          padding: 0,
          border: 0,
          background: "transparent",
          color: "#fff",
          outline: 0,
          cursor: "pointer",
        }}
        onClick={onClick}
        data-id={id}
      >
        <ProgressiveImage
          delay={500}
          src={picture.replace(/.png|.jpg|.jpeg/, (match) => `.218${match}`)}
          placeholder={picture.replace(
            /.png|.jpg|.jpeg/,
            (match) => `.1${match}`
          )}
        >
          {(src) => <img src={src} alt={title} width={218} height={123} />}
        </ProgressiveImage>
        <p
          style={{
            margin: 0,
            fontSize: 16,
            lineHeight: 1.5,
            whiteSpace: "nowrap",
          }}
        >
          {title}
        </p>
      </RadioButton>
    ) : (
      <ChannelLink
        key={id}
        to={`/${channelType}/${id}/${title.replace(".", "_")}`}
        hd={`${isHd}`}
        flag={countryIcon}
      >
        <ProgressiveImage
          delay={500}
          src={picture.replace(/.png|.jpg|.jpeg/, (match) => `.218${match}`)}
          placeholder={picture.replace(
            /.png|.jpg|.jpeg/,
            (match) => `.1${match}`
          )}
        >
          {(src) => <img src={src} alt={title} width={218} height={123} />}
        </ProgressiveImage>

        <p
          style={{
            margin: 0,
            fontSize: 16,
            lineHeight: 1.5,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {title}
        </p>
      </ChannelLink>
    );
  }
}

export default ChannelItem;
